import {useEffect, useState} from "react";
import {getFieldWorkers, getSuperVisor} from "../../service/UserService";
import {mapItemsById} from "./schedulerUtils";

export default function useSchedulerResources() {
    const [fieldWorkerArray, setFieldWorkerArray] = useState([]);
    const [fieldWorkerMap, setFieldWorkerMap] = useState({});
    const [fieldSupervisorMap, setFieldSupervisorMap] = useState({});

    useEffect(() => {
        let isMounted = true;

        async function loadResources() {
            try {
                const [workersResponse, supervisorsResponse] = await Promise.all([
                    getFieldWorkers(),
                    getSuperVisor(),
                ]);

                if (!isMounted) {
                    return;
                }

                if (workersResponse.status === 200) {
                    const workers = await workersResponse.json();
                    setFieldWorkerArray(workers);
                    setFieldWorkerMap(mapItemsById(workers));
                } else {
                    console.log(await workersResponse.text());
                }

                if (supervisorsResponse.status === 200) {
                    const supervisors = await supervisorsResponse.json();
                    setFieldSupervisorMap(mapItemsById(supervisors));
                } else {
                    console.log(await supervisorsResponse.text());
                }
            } catch (error) {
                console.log("error", error);
            }
        }

        loadResources();

        return () => {
            isMounted = false;
        };
    }, []);

    return {
        fieldWorkerArray,
        fieldWorkerMap,
        fieldSupervisorMap,
    };
}
